export default {
    top_menu: [
        {name:'principale',    id:0},
        {name:'Show-business', id:1},
        {name:'Cuisson',  id:2},
        {name:'Politique',   id:3},
        {name:'Épicé',  id:4},
        {name:'Société',   id:5},
        {name:'Santé',   id:6},
    ],
    read_other: 'Lire la suite',
    read_more:  'Plus de détails',
    not_found:  "Rien n'a été trouvé",
    read_also:  'Lire aussi',
    copy_rights: 'Copyright © 2019 «mixer-novostei.ru». Tous les droits sont réservés.',
    subscribe: "S'abonner à",
    thank_order: 'MERCI POUR VOTRE COMMANDE',
        specialist_contact: 'Notre spécialiste vous contactera bientôt, attendez notre appel.',
    attention: 'Remises des partenaires:',
    hurry: "Dépêchez-vous, le temps d'activation de la remise est limité ! Vous n'avez que <span id='time' class='time'>30:00</span> minutes pour choisir l'un de ces produits uniques:",

    hour_ago1: "Une heure avant",
        hour_ago2: "il y a des heures",
    hour_ago3: "il y a des heures",
    new_publications: "Nouvelles parutions",
    read: "Lire",
    today_at: "Aujourd'hui à",
    author_names: ['Philippe Catherine','Clara Luciani','Christophe Mahé'],
    main_news: "Principales nouvelles",
    leave_already: "Vous partez déjà ? Attendez, nous avons mis à jour les nouvelles pour vous",
    already_shared: "déjà partagé"
}